import { FaIcon, IconProps } from './faIcon';

export function CloseIcon(props: Omit<IconProps, 'name'>) {
  return <FaIcon name="xmark" {...props} />;
}
